import { render, staticRenderFns } from "./Copy.vue?vue&type=template&id=7236046f&scoped=true&"
import script from "./Copy.vue?vue&type=script&lang=js&"
export * from "./Copy.vue?vue&type=script&lang=js&"
import style0 from "./Copy.vue?vue&type=style&index=0&id=7236046f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7236046f",
  null
  
)

component.options.__file = "Copy.vue"
export default component.exports